import { apiClient } from '@copro/api';
import { useQuery } from '@tanstack/react-query';
import { keys } from './keys';

async function fetchQuoteColumns(groupId: string) {
  const { data, error } = await apiClient
    .from('quote_comparison_columns')
    .select('*')
    .eq('group_id', groupId)
    .order('order');

  if (error) {
    throw error;
  }

  return data;
}

export function useGetQuoteColumns(groupId: string | undefined) {
  return useQuery({
    queryKey: keys.columns(groupId ?? ''),
    queryFn: () => fetchQuoteColumns(groupId!),
    enabled: !!groupId,
  });
}
